import PropTypes from 'prop-types'
import React from 'react'

import WCoveringDesktop from './components/WCoveringDesktop'
import WCoveringMobile from './components/WCoveringMobile'

const WCovering = props => {
  const { mobile, tablet, breakpoint } = props.viewport

  if (mobile || tablet || breakpoint === '') {
    return <WCoveringMobile {...props} />
  }

  return <WCoveringDesktop {...props} />
}

WCovering.propTypes = {
  viewport: PropTypes.shape({
    mobile: PropTypes.bool.isRequired,
    tablet: PropTypes.bool.isRequired,
    breakpoint: PropTypes.string.isRequired,
  }).isRequired,
}

export default WCovering
